import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
import Container from '../../common/Container';
export const IntroContainer = styled(Container) `
  height: fit-content;
  & > * {
    flex: 1;
  }
`;
export const CTAsContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.md}px;

  ${media.tablet `
    flex-direction: column !important;
    
    a, button {
      width: 100% !important;
    }
  `}
`;
